import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useScreen } from '../_load/ScreenLoader'
import ColorPicker from '../../../../packages/kiti/components/form/ColorPicker'
import DynamicFiltersList from '../../../../containers/dynamic/DynamicFiltersList'
import FilterInput from '../../../../components/form/FilterInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'

const GeneralSection = () => {
  const { t } = useTranslation('screens')
  const form = useForm()
  const screen = useScreen()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={t('color')} field="color" Input={ColorPicker} />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem
          label={t('filters')}
          field="filters"
          Input={FilterInput}
          filtersList={
            <DynamicFiltersList type={screen.screen} showExternalDataFilter={true} showContainsInNameFilter={true} />
          }
        />
      </Col>
    </Grid>
  )
}
export default GeneralSection
